import React from 'react';
import { Row, Col } from 'react-flexa';
import { brandImageLinks } from '../data/constants';
import { withStyles } from '@material-ui/core/styles';
import Image from '../../components/Image';

const styles = theme => ({
  root: {
    maxWidth: 1343,
    margin: '20px auto 0',
    [theme.breakpoints.down('321')]: {
      paddingBottom: '3rem'
    }
  },
  brandCol: {
    margin: '2.5rem 0',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0'
    }
  }
});

class BrandGrid extends React.Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const { classes } = this.props;
    return (
      <Row className={classes.root}>
        {brandImageLinks.map(image => (
          <Col className={classes.brandCol} key={image} xs={4} sm={4} md={2}>
            <Image
              style={{ maxWidth: '100%', verticalAlign: 'middle' }}
              src={image}
            />
          </Col>
        ))}
      </Row>
    );
  }
}

export default withStyles(styles)(BrandGrid);
